import { Component, OnInit } from '@angular/core';
import { SectionRowComponent } from './section-row.component';

@Component({
  moduleId: module.id,
  selector: 'section-row-ca',
  templateUrl: './section-row-ca.component.html',
})
export class SectionRowCAComponent extends SectionRowComponent implements OnInit {
  ngOnInit() {
    super.ngOnInit();
  }
}
